<template>
  <div class="pay-wrap">
    <div class="pay-head-box">
      <div class="line-box"><img src="@/assets/img/fail_icon.png" /></div>
      <div class="tips_zh">支付失败</div>
      <div class="btn-box"><van-button round type="ponhu" block @click.stop="checkOrder">查看订单</van-button></div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    checkOrder() {
      this.$router.push({ name: 'shopOrderDetail', params: { oid: this.$route.query.so } })
    }
  }
}
</script>

<style lang="less" scoped>
.pay-wrap {
  display: flex;
  flex-direction: column;
  height: calc(100vh);
  background: #fff;
  width: 750px;
  .pay-head-box {
    text-align: center;
    padding-top: 158px;
    .line-box {
      display:inline-block;
      img {
        width: 70px;
        height: 70px;
      }
    }
    .tips_zh{
      font-size: 36px;
      font-weight: 400;
      color: #282828;

    }
    .btn-box {
      margin-top: 60px;
      padding: 0 235px;
    }
  }
}
</style>


